var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNewCloseIcon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1668 16.4987C22.1668 13.1082 19.3907 10.332 16.0002 10.332C12.6096 10.332 9.8335 13.1082 9.8335 16.4987C9.8335 19.8892 12.6096 22.6654 16.0002 22.6654C19.3907 22.6654 22.1668 19.8892 22.1668 16.4987ZM23.1668 16.4987C23.1668 20.4415 19.943 23.6654 16.0002 23.6654C12.0574 23.6654 8.8335 20.4415 8.8335 16.4987C8.8335 12.5559 12.0574 9.33203 16.0002 9.33203C19.943 9.33203 23.1668 12.5559 23.1668 16.4987Z",
    fill: "#395ABF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5331 14.2597C17.7284 14.0645 18.0449 14.0645 18.2402 14.2597C18.4354 14.455 18.4354 14.7715 18.2402 14.9667L14.4667 18.7402C14.2715 18.9354 13.955 18.9354 13.7597 18.7402C13.5645 18.5449 13.5645 18.2284 13.7597 18.0331L17.5331 14.2597Z",
    fill: "#395ABF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7597 14.2597C13.955 14.0645 14.2715 14.0645 14.4668 14.2597L18.2402 18.0332L18.2747 18.0709C18.4348 18.2673 18.4232 18.5572 18.2402 18.7402C18.0572 18.9232 17.7673 18.9348 17.5709 18.7747L17.5332 18.7402L13.7597 14.9668C13.5645 14.7715 13.5645 14.455 13.7597 14.2597Z",
    fill: "#395ABF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new-close-icon.406b84b2.svg";
export { ForwardRef as ReactComponent };